<footer
  class=" {{ footerClass ? footerClass : 'page-footer' }}"
  [ngClass]="{ 'font-small': !layout }"
>
  <div class="footer-container">
    <div class="inner">
      <div class="row">
        <ng-container *ngIf="!layout && model">
          <div class="col-12 col-md-4">Version: {{ model.version }}</div>
          <div class="col-12 col-md-4"></div>
          <div class="col-12 col-md-4 text-right">
            © {{ model.initialYear }} - {{ model.currentYear }}
            <a href="{{ model.url }}" target="_blank">{{ model.siteName }}</a>
          </div>
        </ng-container>
      </div>
      <rr-list-builder *ngIf="layout" [autoColClass]="true" [layout]="layout">
      </rr-list-builder>
    </div>
  </div>
</footer>
